export const ANIMATION_TYPES = {
  gifs: 'GIFs',
  threeD: '3D',
};
